import { render, staticRenderFns } from "./FaqItem.vue?vue&type=template&id=8d065492&scoped=true&"
import script from "./FaqItem.vue?vue&type=script&lang=ts&"
export * from "./FaqItem.vue?vue&type=script&lang=ts&"
import style0 from "./FaqItem.vue?vue&type=style&index=0&id=8d065492&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d065492",
  null
  
)

export default component.exports